// DriveAppNav.jsx
import * as React from "react";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppsIcon from "@mui/icons-material/Apps";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import AssessmentIcon from "@mui/icons-material/Assessment";
import GavelIcon from "@mui/icons-material/Gavel";
import { useNavigate, useLocation } from "react-router-dom";

export default function DriveAppNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const openMenu = (e) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  // Keeps behavior simple: if history exists go back, else fallback
  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/dashboard");
  };

  const items = [
    { label: "My Dashboard", icon: <DashboardIcon fontSize="small" />, to: "/dashboard" },
    { label: "All Trackers", icon: <TrackChangesIcon fontSize="small" />, to: "/alltrackers" },
    { label: "Reports", icon: <AssessmentIcon fontSize="small" />, to: "/reports/ageing_report" },
    { label: "Legal Updates", icon: <GavelIcon fontSize="small" />, to: "/legal-update" },
  ];

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        minHeight: 44,
        px: 2,
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "transparent",
      }}
    >
      <Tooltip title="Back to app">
        <Button
          onClick={handleBack}
          startIcon={<ArrowBackIcon />}
          variant="text"
          sx={{
            borderRadius: 999,
            textTransform: "none",
            fontWeight: 700,
            px: 1.5,
          }}
        >
          Back
        </Button>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      <Tooltip title="Open app navigation">
        <IconButton
          onClick={openMenu}
          size="small"
          sx={{
            borderRadius: 2,
            bgcolor: "action.hover",
            "&:hover": { bgcolor: "action.selected" },
          }}
        >
          <AppsIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
        You’re in Drive
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      {/* optional “where am I” chip */}
      <Chip
        size="small"
        label={location.pathname}
        variant="outlined"
        sx={{ display: { xs: "none", md: "inline-flex" } }}
      />

      <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
        {items.map((it) => (
          <MenuItem
            key={it.to}
            onClick={() => {
              navigate(it.to);
              closeMenu();
            }}
            sx={{ gap: 1.25 }}
          >
            {it.icon}
            {it.label}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
}
